const copy = {
  title: "Plus icon",
  addButtonValue: "Add",
  cancelButtonValue: "Cancel",
  updateButtonValue: "Update",
  editButtonValue: "Edit",
  defaultPlaceholder: "Enter a value",
};

export default copy;
